/**
 * Page transitions with swup
 *
 * @link https://swup.js.org/
 */

// TODO https://swup.js.org/plugins/a11y-plugin/

import Swup from "swup";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupHeadPlugin from "@swup/head-plugin";
import SwupMorphPlugin from "swup-morph-plugin";
import SwupJsPlugin from "@swup/js-plugin";
import SwupParallelPlugin from "@swup/parallel-plugin";
import SwupMergeAssetsPlugin from "./scripts-SwupMergeAssetsPlugin.jsx";
import {
  HomeToProjectAnimation,
  ProjectToHomeAnimation,
  DefaultTransition,
} from "./scripts-animations.jsx";

class LutherPageTransitions {
  constructor() {
    this.initSwup();
  }

  initSwup() {
    this.swup = new Swup({
      // Diese Container sollen beim Seitenwechsel ausgetauscht werden
      containers: [".main-content"],
      plugins: [
        // Benötigt, damit der neue under Alte Conatiner parallel sichtbar sind
        new SwupParallelPlugin(),
        // Benötigt, damit der head ausgetauscht wird
        new SwupHeadPlugin({
          persistAssets: true,
          awaitAssets: true,
        }),
        // Benötigt, damit die Assets aus dem Footer in den neuen Footer übernommen werden
        new SwupMergeAssetsPlugin({
          containers: ["#luther-footer-assets-wrapper"],
          persistAssets: true,
          awaitAssets: true,
        }),
        // Benötigt, damit die Menüs gemorpht werden
        new SwupMorphPlugin({
          containers: ["#menu-desktop-menue"],
        }),
        // Benötigt, um die Animationen mit JS zu steuern
        new SwupJsPlugin({
          animations: [
            HomeToProjectAnimation,
            ProjectToHomeAnimation,
            DefaultTransition,
          ],
        }),
        // Hilfreich, damit Seiten beim hover über einen Link vorgeladen werden
        new SwupPreloadPlugin(),
      ],
    });

    this.swup.hooks.on("page:view", (visit) => {
      window.luther.eventBus.emit("luther:pageContentChange", {
        detail: { visit },
      });
    });
  }
}

window.luther = window.luther || {};
window.luther.pageTransitions = window.luther.pageTransitions || {};

window.luther.pageTransitions = new LutherPageTransitions();
